<!-- 巡检角色管理 -->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    />
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove } from "./api";

export default {
  name: "inspection-role-manage",
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, add, update, remove },
      option: {
        ...this.$store.state.publicOption,
        rowKey: "roleId",
        column: [
          {
            label: "角色ID",
            prop: "roleId",
            width: 180,
            overHidden: true,
            addDisplay: false,
            editDisabled: true,
          },
          {
            label: "角色名称",
            prop: "roleName",
            maxlength: 50,
            search: true,
            rules: [
              {
                required: true,
                message: "请输入角色名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "备注",
            prop: "remark",
            type: "textarea",
            span: 24,
            minRows: 3,
            maxRows: 6,
            maxlength: 200,
            overHidden: true,
            search: true,
          },
        ],
      },
    };
  },
  methods: {
    rowDel(row) {
      this.$confirm("确定删除选中信息？").then(() => {
        this.loading = true;
        this.apiConfig
          .remove(row.roleId)
          .then(() => {
            this.selectionClear();
            this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功",
            });
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
